import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
} from '@angular/forms';
import { distinctUntilChanged, merge } from 'rxjs';
import { CommonComponent } from '@components/abstract/common-component.component';
import { SimpleArrayTypeModel } from '@models/calendar/simpleArrayType.model';
import { debounceTime } from 'rxjs/operators';
import moment from 'moment/moment';

@Component({
  selector: 'app-meridian',
  templateUrl: './meridian.component.html',
  styleUrls: ['./meridian.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MeridianComponent),
      multi: true,
    },
  ],
})
export class MeridianComponent
  extends CommonComponent
  implements ControlValueAccessor, OnInit
{
  @Input() times: SimpleArrayTypeModel[] = [];
  @Input() meridian: SimpleArrayTypeModel[] = [];
  @Output() updated = new EventEmitter<string>();
  selected: any;

  timesControl = new UntypedFormControl();
  meridianControl = new UntypedFormControl();

  private onChange: (value: any) => void;
  public registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }
  onTouched: () => void;
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {
    this.selected = value;
    this.calculate(value);
  }

  ngOnInit(): void {
    this.unsubscribe.push(
      merge(this.timesControl.valueChanges, this.meridianControl.valueChanges)
        .pipe(debounceTime(50), distinctUntilChanged())
        .subscribe({
          next: () => this.change(),
        })
    );
  }
  change() {
    const time = `${this.timesControl.value} ${this.meridianControl.value}`;
    const parse = moment(time, 'h:mm A');
    const format = parse.format('HH:mm:ss');
    this.onChange(format);
    this.updated.emit(format);
  }

  calculate(value: any) {
    //this.onChange(value);
    if (value) {
      const parse = moment(value, 'HH:mm:ss');
      this.timesControl.patchValue(parse.format('h:mm'));
      this.meridianControl.patchValue(parse.format('A'));
    }
  }
}
